<template>
  <DetailTemplate banner-type="daRenGongLue" :tag="true"></DetailTemplate>
</template>

<script>
import DetailTemplate from "~/components/template/DetailTemplate.vue";
export default {
  components: {DetailTemplate}
}
</script>



// WEBPACK FOOTER //
// src/views/service/strategyInfo.vue